export default "__VITE_ASSET__d4927351__"